/*
 * @Descripttion:
 * @version:
 * @Author: leon
 * @email: leon0023@zoho.com.cn
 * @Date: 2022-09-28 17:23:27
 * @LastEditors: linxi
 * @LastEditTime: 2023-12-20 20:05:02
 */
import { PlusOutlined } from '@ant-design/icons'
import { unwrapResult } from '@reduxjs/toolkit'
import {
  Modal,
} from 'antd'
import moment from 'moment'
import React, { ReactElement, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { RootDispatch } from '../../../../app/store'
import { getdrugTradeCodeListAsync } from './TraceCodeScanRateSlice'
import { EditableList } from '../../../../compnents/list/EditableList'
import { NoTraceCodeRecordColumns } from './column'
import { TraceCodeInputModal } from '../../../payment/list/TraceCodeInputModal'
import { getPaymentResults } from '../../../payment/result/paymentResultSlice'

interface NoTraceCodeRecordModalProps {
  visible: boolean
  params?: any
  onCancel: () => void
  onOk: () => void
}

export const NoTraceCodeRecordModal = ({
  visible,
  params,
  onCancel,
  onOk,
}: NoTraceCodeRecordModalProps): ReactElement => {

  const dispatch = useDispatch<RootDispatch>()

  const [showCodeInputModal, setShowCodeInputModal] = useState(false)

  const [result, setResult] = useState<any>()

  const [page, setPage] = useState<any>({
    items: [],
    total: 0,
  })

  const [queries, setQueries] = useState<any>({
    current: 1,
    size: 10,
  })

  const [pageLoading, setPageLoading] = useState(false)

  useEffect(() => {
    if (visible) {
      setPageLoading(true)
      getPage()
    }
     
  }, [visible, queries])

  const getPage = () => {
    dispatch(getdrugTradeCodeListAsync({ ...params, ...queries }))
        .then(unwrapResult)
        .then((v: any) => {
          setPage({
            items: v?.records || [],
            total: v?.total
          })
        })
        .finally(() => {
          setPageLoading(false)
        })
  }

  useEffect(() => {
    if (!visible) {
      setQueries({
        ...queries,
        current: 1,
        size: 10,
      })
    }
  }, [visible])

  return (
    <>
      <Modal
        visible={visible}
        title='补传追溯码'
        width={1000}
        bodyStyle={{ height: '550px' }}
        footer={null}
        onCancel={onCancel}
      >
        <EditableList
          loading={pageLoading}
          scroll={{ y: page?.items?.length && '414px', x: 'auto' }}
          columns={NoTraceCodeRecordColumns(queries.size * (queries.current - 1), (action, t) => {
            if (action == 'traceCode') {
              dispatch(getPaymentResults(t?.paymentId))
                .then(unwrapResult)
                .then(async (val: any) => {
                  setResult(val)
                  setShowCodeInputModal(true)
                })
            }
          })}
          style={{ height: '455px', overflow: 'hidden' }}
          page={{
            current: queries?.current || 1,
            size: queries?.size || 10,
            total: page?.total,
            items: page?.items || [],
          }}
          pagination={page?.total}
          rowKey={(record: any) => record?.id}
          onChangePage={(current, size) => {
            setQueries({
              ...queries,
              current: current,
              size: size || 10,
            })
          }}
        />
      </Modal>
      <TraceCodeInputModal
        showCodeInputModal={showCodeInputModal}
        onCancel={() => {
          setShowCodeInputModal(false)
          getPage()
        }}
        onOk={() => {
          setShowCodeInputModal(false)
          getPage()
        }}
        paymentResult={result}
        isShowUpload={result?.ybSaleUploadStatus == 0 ? true : false}
      />
    </>
  )
}
